// pages/NewAnnoncePage.tsx

import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageListLayout from "../../../layouts/PageListLayout";
import AnnonceForm from "../../../components/features/annonces/AnnonceForm";
import { alertSuccess, alertError } from "../../../helpers/alertError";
import useAnnonces from "../../../hooks/annonces/useAnnonces";

export default function NewAnnoncePage() {
  const navigate = useNavigate();
  const { createAnnonce, loading } = useAnnonces();

  const handleSubmit = async (data: any) => {
    try {
      const result = await createAnnonce(data);
      if (result) {
        alertSuccess("Annonce créée avec succès");
        navigate("/admin/annonces");
      }
    } catch (error) {
      alertError("Erreur lors de la création de l'annonce");
      console.error(error);
    }
  };

  return (
    <PageListLayout title="">
      <div className="px-6 py-5 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate("/admin/annonces")}
              className="p-2 hover:bg-gray-100 rounded-xl transition-all duration-300 group"
            >
              <ArrowLeft size={20} className="text-gray-600 group-hover:text-primary transition-colors" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-[#031B4E] tracking-tight">Nouvelle annonce</h1>
              <p className="text-sm text-slate-400 font-light mt-0.5">
                Créez une annonce à destination des utilisateurs de la plateforme
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 py-8 max-w-3xl mx-auto">
        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
          <AnnonceForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/admin/annonces")}
            isLoading={loading}
          />
        </div>
      </div>
    </PageListLayout>
  );
}